import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserAdd } from '@classes/user/userAdd';
import { AuthService } from '@services/auth/auth.service';

import * as CryptoJS from 'crypto-js'
@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {

  createUserForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  onSubmit(): void {
    const newUser: UserAdd = {
      username: this.createUserForm.get('user').value,
      email: this.createUserForm.get('email').value,
      password: CryptoJS.SHA256(this.createUserForm.get('password').value).toString()
    }
    if (this.createUserForm.get('password').value === this.createUserForm.get('confirmPassword').value) {
      this.authService.addNewUser(newUser).subscribe(() => { }, error => {
      });
    }
  }

  private initForm(): void {
    this.createUserForm = this.formBuilder.group({
      user: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });
  }


}
